import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";
import { getSessionId } from "./authService";

const AGENT_SEO_ARTICLES_PATH = "/api/agent/seo-articles";

function articlesUrl(suffix = "") {
  return resolveApiUrl(`${AGENT_SEO_ARTICLES_PATH}${suffix}`);
}

async function withSessionRequestConfig() {
  const sessionID = await getSessionId();
  if (!sessionID) {
    throw new Error("agent_seo_articles_no_session");
  }
  const sid = String(sessionID).trim();
  return {
    headers: {
      "Content-Type": "application/json",
      "X-Session-ID": sid,
    },
    withCredentials: true,
    timeout: 30000,
    sid,
  };
}

export async function fetchAgentSeoArticles() {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.get(articlesUrl(), cfg);
  return Array.isArray(data?.articles) ? data.articles : [];
}

export async function createAgentSeoDraft(payload) {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.post(
    articlesUrl("/draft"),
    {
      destination: payload?.destination,
      category: payload?.category,
      topic: payload?.topic,
      tone: payload?.tone,
      sessionID: cfg.sid,
    },
    cfg
  );
  return data?.article || null;
}

export async function createAgentSeoAiDraft(payload) {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.post(
    articlesUrl("/ai-draft"),
    {
      destination: payload?.destination,
      category: payload?.category,
      topic: payload?.topic,
      tone: payload?.tone,
      sessionID: cfg.sid,
    },
    cfg
  );
  return {
    article: data?.article || null,
    message: data?.message || null,
    fallback_used: Boolean(data?.fallback_used),
  };
}

export async function patchAgentSeoArticle(articleId, payload) {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.patch(
    articlesUrl(`/${encodeURIComponent(String(articleId))}`),
    {
      title: payload?.title,
      slug: payload?.slug,
      topic: payload?.topic,
      destination: payload?.destination,
      category: payload?.category,
      meta_title: payload?.meta_title,
      meta_description: payload?.meta_description,
      content_markdown: payload?.content_markdown,
      sessionID: cfg.sid,
    },
    cfg
  );
  return data?.article || null;
}

export async function publishAgentSeoArticle(articleId) {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.post(
    articlesUrl(`/${encodeURIComponent(String(articleId))}/publish`),
    { sessionID: cfg.sid },
    cfg
  );
  return data || {};
}

export async function deleteAgentSeoArticle(articleId) {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.delete(
    articlesUrl(`/${encodeURIComponent(String(articleId))}`),
    {
      ...cfg,
      data: { sessionID: cfg.sid },
    }
  );
  return data || {};
}
